export default "__VITE_ASSET__ot_5OVPE__"